import { borderBottom } from "@material-ui/system";

/* Response Time CSS */

export default theme => ({
    rootClassName:{
        width:"100%"
    },
    snackContent: {
        backgroundColor: theme.palette.error.dark,
      },
      snackContentOk: {
        backgroundColor: theme.palette.success.main,
      },
      message: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 15,
      },
      icon: {
        fontSize: 20,
      },
      iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(2),
      },
      // ---- BOTONES Y BARRA ARRIBA, CHIPS ABAJO ----
      autocompleteEndAdornment: {
        top: '12px !important',      // Fijamos los íconos X y ▲ en la parte superior
        bottom: 'auto !important',
        right: '9px !important',
        position: 'absolute !important'
      },
      autocompleteInputRoot: {
          display: 'flex !important',
          flexDirection: 'column-reverse !important', // Invierte el orden: Input arriba, chips abajo
          alignItems: 'flex-start !important',
          paddingRight: '65px !important',
          paddingTop: '8px !important'
      },
      // ---- GARANTIZA EL MARGEN SUPERIOR DEL MENÚ FLOTANTE ----
      autocompletePaper: {
        marginTop: '4px !important'
      },
      // ---- CONTENEDOR EXCLUSIVO PARA LOS CHIPS (GRID HORIZONTAL) ----
      tagsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px',
        width: '100%',
        marginTop: '8px'
    }
});

